export const MARKETING_ROLES = [
  { slug: 'founders-emerging-brands', label: 'Founders & Emerging Brands' },
  { slug: 'creative-directors', label: 'Creative Directors' },
  { slug: 'fashion-designers', label: 'Fashion Designers' },
  {
    slug: 'technical-design-development',
    label: 'Technical Design & Development',
  },
  { slug: 'marketing-ecommerce', label: 'Marketing & Ecommerce' },
  { slug: 'merchandisers-buyers', label: 'Merchandisers & Buyers' },
  { slug: 'sourcing-supply-chain', label: 'Sourcing & Supply Chain' },
  { slug: 'manufactures-factories', label: 'Manufactures & Factories' },
] as const;

export type MarketingRole = (typeof MARKETING_ROLES)[number];
export type MarketingRoleSlug = MarketingRole['slug'];

/** Role-page reviews are temporarily hidden; their copy stays editable. */
export const SHOW_ROLE_TESTIMONIALS: boolean = false;

const ROLE_BY_SLUG = new Map<string, MarketingRole>(
  MARKETING_ROLES.map((role) => [role.slug, role])
);

export function marketingRoleHref(slug: string): string {
  return `/roles/${slug}`;
}

export function getMarketingRole(slug: string): MarketingRole | null {
  return ROLE_BY_SLUG.get(slug) ?? null;
}

/** Footer omits Merchandisers & Buyers; the Solutions menu uses every role. */
export const MARKETING_FOOTER_ROLE_SLUGS = [
  'founders-emerging-brands',
  'creative-directors',
  'fashion-designers',
  'technical-design-development',
  'marketing-ecommerce',
  'sourcing-supply-chain',
  'manufactures-factories',
] as const;

export function marketingRoleLinks(
  slugs: ReadonlyArray<string>
): Array<{ label: string; href: string }> {
  const links: Array<{ label: string; href: string }> = [];
  for (const slug of slugs) {
    const role = ROLE_BY_SLUG.get(slug);
    if (!role) continue;
    links.push({ label: role.label, href: marketingRoleHref(role.slug) });
  }
  return links;
}
